import type React from 'react'

/** Prevent Type panel clicks from blurring the canvas text editor, but allow input elements to work. */
export function keepTextEditFocus(e: React.PointerEvent) {
  const target = e.target as HTMLElement
  const tagName = target.tagName.toLowerCase()

  if (tagName === 'input' || tagName === 'textarea') {
    return
  }

  // Wrapper div containing an input (e.g. InputGroup): explicitly focus the nested input
  const nestedInput = target.querySelector<HTMLElement>('input, textarea')

  if (nestedInput) {
    nestedInput.focus()
    return
  }

  // This preventDefault only needs to protect the CANVAS's own live-edit textarea focus — if a
  // `[data-text-edit-keepalive]` control (e.g. a different panel field, mid-edit) already holds
  // focus, let this click blur it normally so its own commit/validation-on-blur logic runs (e.g.
  // Kerning/Leading/Tracking's required-field check); that handler already calls
  // `restoreActiveEditor()` itself afterward to put focus back on the canvas. Without this check,
  // clicking any inert panel chrome (a label, slider track) while a field is showing a blur error
  // re-traps focus in that field before its blur ever fires, so the error/revert never happens.
  // Mirrors the same `closest('[data-text-edit-keepalive]')` check `shape-text-editor/hooks/use-shape-text-editing.ts`
  // uses to decide whether focus moving away should end the edit session.
  if ((document.activeElement as HTMLElement | null)?.closest('[data-text-edit-keepalive]')) {
    return
  }

  e.preventDefault()
}
